import MDropdown from './MDropdown.vue';

MDropdown.install = (app) => {
  app.component('MDropdown', MDropdown);
};

export { MDropdown };
